module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_7016.4ceafd4c.png";